import "./scss/main.scss"
import "./assets/driver.min.css"
import "floating-vue/dist/style.css"

import { createApp } from "vue"
import App from "./App.vue"
import { createI18nWithRemote } from "./i18n"
import { createVuestic } from "vuestic-ui"
import { createGtm } from "@gtm-support/vue-gtm"
import { setup as setupAuth } from "./services/authenticationPlugin"
import ConfigService from "@shared/helpers/configServices"

import stores from "./stores"
import { createAppRouter } from "./router"
import vuesticGlobalConfig from "./services/vuestic-ui/global-config"
import createAxiosInstance from "./axios"
import permission from "./directives/permission"
import { vTooltip } from "floating-vue"
import MaskInput from "@shared/components/core/MaskInput.vue"
import SelectInput from "@shared/components/core/SelectInput.vue"
import InfoField from "@shared/components/core/InfoField.vue"
import LabelButtonTogle from "@shared/components/core/LabelButtonToggle.vue"
import SwitchInput from "@shared/components/core/SwitchInput.vue"
import PageTitle from "@shared/components/layout/PageTitle.vue"
import PaginationControl from "@shared/components/PaginationControl.vue"
import BaseDataTable from "@shared/components/BaseDataTable.vue"
import BasePage from "@shared/components/BasePage.vue"
import useUserStore from "./stores/user-store"
import { useGlobalStore } from "./stores/global-store"

async function bootstrap() {
  const app = createApp(App)
  const i18n = await createI18nWithRemote()
  const router = await createAppRouter()

  app.directive("permission", permission)
  app.directive("tooltip", vTooltip)

  app.component("MaskInput", MaskInput)
  app.component("SelectInput", SelectInput)
  app.component("InfoField", InfoField)
  app.component("LabelButtonToggle", LabelButtonTogle)
  app.component("SwitchInput", SwitchInput)
  app.component("PageTitle", PageTitle)
  app.component("PaginationControl", PaginationControl)
  app.component("BaseDataTable", BaseDataTable)
  app.component("BasePage", BasePage)

  app.use(stores)
  app.use(i18n)

  app.use(router)
  app.use(createVuestic({ config: vuesticGlobalConfig }))
  const baseAxios = await createAxiosInstance(ConfigService.Current.apis.base)
  app.provide("$baseHttpClient", baseAxios)
  const policyAxios = await createAxiosInstance(ConfigService.Current.apis.policy)
  app.provide("$policyHttpClient", policyAxios)
  const reportAxios = await createAxiosInstance(ConfigService.Current.apis.reportTool, "accessToken")
  app.provide("$reportHttpClient", reportAxios)
  app.provide("msalInstance", setupAuth())
  app.provide("$config", ConfigService.Current)

  // Expose stores globally AFTER Pinia is installed
  const userStore = useUserStore()
  const globalStore = useGlobalStore()

  // Make stores available globally
  window.__HOST_STORES__ = {
    userStore,
    globalStore,
  }

  window.__I18N__ = i18n.global

  if (import.meta.env.VITE_APP_GTM_ENABLED) {
    app.use(
      createGtm({
        id: import.meta.env.VITE_APP_GTM_KEY,
        debug: false,
        vueRouter: router,
      }),
    )
  }

  app.mount("#app")
}

ConfigService.load().then(async () => {
  bootstrap()
})
